import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class NgTemplateService {
    constructor(
        private cvApiService: CVApiService, // Inject not needed, since it's already written in TypeScript
    ) { }

    public async loadTemplateSampleData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const response = await this.cvApiService.get<TemplateSampleModuleData>(`${renderEndpoint}/api/v2/dashboards/modules/templatemodules/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    }
}

export interface TemplateSampleModuleData {
    RowValues: TemplateSampleModuleRow[];
}

export interface TemplateSampleModuleRow {
    ID: number;
    Message: string;
}
